import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { Notification } from '../../hooks/notifications/useNotifications';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

interface NotificationItemProps {
  notification: Notification;
  tripUrl: string | undefined;
}

/**
 * Individual notification item component.
 * Displays notification message, unread indicator, and time.
 * Uses Link for proper navigation UX (right-click, URL preview, etc.)
 */
export function NotificationItem({ notification, tripUrl }: NotificationItemProps) {
  const timeAgo = formatDistanceToNow(new Date(notification.creation), { addSuffix: true });

  // If no URL, render as disabled div
  if (!tripUrl) {
    return (
      <div className="w-full text-left px-4 py-4 opacity-50 cursor-not-allowed">
        <div className="flex items-start gap-3">
          {!notification.read && (
            <span className="mt-1.5 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-action-primary" />
          )}
          <div className={classNames('flex-1 min-w-0', notification.read ? 'ml-5' : '')}>
            <p className="text-sm text-main">{notification.message}</p>
            <p className="text-xs text-muted mt-1">{timeAgo}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Link
      to={tripUrl}
      className="block w-full text-left px-4 py-4 hover:bg-subtle transition-colors"
    >
      <div className="flex items-start gap-3">
        {!notification.read && (
          <span className="mt-1.5 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-action-primary" />
        )}
        <div className={classNames('flex-1 min-w-0', notification.read ? 'ml-5' : '')}>
          <p className="text-sm text-main">{notification.message}</p>
          <p className="text-xs text-muted mt-1">{timeAgo}</p>
        </div>
      </div>
    </Link>
  );
}
